export const HOME = '/';
export const SIGNIN = '/signin';
export const MANAGE = '/manage';
export const SEARCH = '/search';
